// Sentinel URL marking an in-flight image generation inside a chat message. Master
// runs (RUN_STUDIO_STEP) emit `![generating](<marker><aspect>)` while a generation
// is running; the chat's image renderer detects the marker and shows the List-Studio
// loading skeleton, then the run swaps the message content in place for the finished
// image. An https sentinel host is used (not a custom scheme or data: URI) because
// react-markdown's default urlTransform strips non-http(s) schemes, which would blank
// the src — and the renderer intercepts it before any <img> is created, so the
// sentinel never triggers a network request.
export const PENDING_IMAGE_MARKER = 'https://pending.fater.local/';
